export class Policy implements IPolicy{
    _id :any;
    category_id     :any[];
    sub_category_id ?:string;
    company_id      :Object;
    insured_name    :String;
    insurance_type    :String;
    policy_holder   :String
    policy_number   :Number
    premium_amount  :Number
    premium_amount_written : Number
    next_premium_date   :String;
    premium_add_date    :String;
    premium_reminder    :String;
    policy_start_date   :String;
    policy_end_date     :String;
    anniversary_date    :String;
    add_deductible      :Number;
    policy_document     :String;
    policy_mode         :String;
    premium_modify_date :String;
    total_amount        :Number;
    premium_due_date    :String;
    user                :Object;
    user_id             :String;
    account_id          :String;
    notes               :String;
    agent               :Object | String;
    coverage            :Object[];
    insuranceCard       :Object[];
    policyData          :Object[];
    beneficiary?        :Object[];
    agency?             :Object[];
    driver?             :Object[];
    vehicle?            :Object[];
    health?             :Object[];
    houseaddress?       :Object[];
    user_defined_fields?  :any[];

    constructor(
        _id :String = undefined,
        category_id = [],
        company_id      :Object = {},
        insured_name    :String = '',
        insurance_type    :String = '',
        policy_holder   :String = '',
        policy_number   :any = undefined,
        premium_amount  :Number = undefined,
        premium_amount_written : Number = undefined,
        next_premium_date   :String = '',
        premium_add_date    :String = '',
        premium_reminder    :String = '',
        policy_start_date   :String = '',
        policy_end_date     :String = '',
        anniversary_date    :String = '',
        add_deductible      :Number = 0,
        policy_document     :String = '',
        policy_mode         = null,
        premium_modify_date :String = '',
        total_amount        :Number = 0,
        premium_due_date    :String = '',
        notes               :String = '',
        user                :Object = {},
        user_id             :String= '',
        agent               :Object | String = '',
        coverage            :Array<Object> = [],
        insuranceCard       :Array<Object> = [],
        policyData          :Array<Object> = [],
        user_defined_fields:any = []
        
    ){
        this._id = _id
        this.category_id = category_id
        this.sub_category_id = null
        this.company_id = company_id
        this.insured_name = insured_name
        this.insurance_type = insurance_type
        this.policy_holder = policy_holder
        this.policy_number = policy_number
        this.premium_amount = premium_amount
        this.premium_amount_written = premium_amount_written
        this.next_premium_date = next_premium_date
        this.premium_add_date = premium_add_date
        this.premium_reminder = premium_reminder
        this.policy_start_date = policy_start_date
        this.anniversary_date = anniversary_date;
        this.policy_end_date = policy_end_date
        this.add_deductible = add_deductible
        this.policy_document = policy_document
        this.policy_mode = policy_mode
        this.premium_modify_date = premium_modify_date
        this.total_amount = total_amount
        this.premium_due_date = premium_due_date
        this.notes = notes
        this.user = user;
        this.agent = agent;
        this.coverage = coverage
        this.insuranceCard = insuranceCard
        this.policyData = policyData
        this.user_defined_fields = user_defined_fields
    }
}
export interface IPolicy{
    _id :any;
    category_id: any[];
    sub_category_id?:string;
    company_id      :Object;
    insured_name    :String;
    insurance_type    :String;
    policy_holder   :String
    policy_number   :Number
    premium_amount  :Number
    premium_amount_written : Number
    next_premium_date   :String;
    premium_add_date    :String;
    premium_reminder    :String;
    policy_start_date   :String;
    policy_end_date     :String;
    anniversary_date:   String;
    add_deductible      :Number;
    policy_document     :String;
    policy_mode         :String;
    premium_modify_date :String;
    total_amount        :Number;
    premium_due_date    :String;
    notes               :String
    user                :Object;
    agent               :Object | String;
    coverage            :Object[];
    insuranceCard       :Object[];
    policyData          :Object[];
    beneficiary?        :Object[];
    agency?             :Object[];
    driver?             :Object[];
    vehicle?            :Object[];
    health?             :Object[];
    houseaddress?       :Object[];
    user_defined_fields? : any[];
}